import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import fontFace from './fontFace';

var fontGroupDeclarations = function fontGroupDeclarations(fonts, baseUrl) {
  var _context;

  return _mapInstanceProperty(_context = _Object$keys(fonts)).call(_context, function (fontKey) {
    var font = fonts[fontKey];
    return fontFace(baseUrl, font);
  }).join('\n');
};

export default fontGroupDeclarations;